import { z } from 'zod';

export const workspaceTypes = ['ledger', 'payments'] as const;
export const WorkspaceTypeSchema = z.enum(workspaceTypes);
export type WorkspaceType = (typeof workspaceTypes)[number];
